export * from './Accordion';
export * from './Card';
export * from './FeatureTable';
export * from './Menu';
export * from './Modal';
export * from './NewsMiniature';
export * from './Slider';
export * from './Socials';
export * from './Tabs';

import Carousel, { CarouselProps } from './Carousel';
export { Carousel, CarouselProps };
